export enum QueryKeys {
  GEO_LOCATION = 'GEO_LOCATION',
  ALLOWANCE = 'ALLOWANCE',
  UI_LOCALIZATION = 'UI_LOCALIZATION',
  LOCK_POSITIONS = 'LOCK_POSITIONS',
  NEWS = 'NEWS',
  USERS_READ_NEWS = 'USERS_READ_NEWS',
  SEASONAL_BANNERS = 'SEASONAL_BANNERS',
  ECOSYSTEM_DAPPS = 'ECOSYSTEM_DAPPS',
  MERKL_DAPPS = 'MERKL_DAPPS',
  COINGECKO_TOKEN_INFO = 'COINGECKO_TOKEN_INFO',
  OP_BALANCES = 'OP_BALANCES',
  STAKED_APY = 'STAKED_APY',
  STAKED_MODE_TOKENS = 'STAKED_MODE_TOKENS',
  STAKED_BPT_TOKENS = 'STAKED_BPT_TOKENS',
  ECOSYSTEM_DAPP_BANNER = 'ECOSYSTEM_DAPP_BANNER',
  GOVERNANCE_VOTE_STATUS = 'GOVERNANCE_VOTE_STATUS',
  MERKL_REWARDS = 'MERKL_REWARDS',
  MERKL_DAPPS_CAMPAIGNS = 'MERKL_DAPPS_CAMPAIGNS',
  GOVERNANCE_CALENDAR = 'GOVERNANCE_CALENDAR',
  REWARDS_BY_WALLET = 'REWARDS_BY_WALLET',
  STAKING_REWARDS_LINKS = 'STAKING_REWARDS_LINKS',
  TRANSACTION_DETAILS = 'TRANSACTION_DETAILS',
  AI_TERMINAL_SUGGESTIONS = 'AI_TERMINAL_SUGGESTIONS',
  USER_CHATS = 'USER_CHATS',
  CHAT_MESSAGES = 'CHAT_MESSAGES',
  PRICE_PREDICTIONS = 'PRICE_PREDICTIONS',
  INSIGHT_LIQUIDATION = 'INSIGHT_LIQUIDATION',
  BTC_PRICE = 'BTC_PRICE',
  LEADERBOARD = 'LEADERBOARD',
  LP_BOUNDS = 'LP_BOUNDS',
  LP_BOUNDS_CHART = 'LP_BOUNDS_CHART',
  INSIGHT_OPTIONS_PRICING = 'INSIGHT_OPTIONS_PRICING',
  WHITELISTED_WALLETS = 'WHITELISTED_WALLETS',
  DERIBIT_PRICE = 'DERIBIT_PRICE',
  DISCOVER_PAGE_ITEMS = 'DISCOVER_PAGE_ITEMS',
  DISCOVER_PAGE = 'DISCOVER_PAGE',
  SYNTH_DISCORD_LINK = 'SYNTH_DISCORD_LINK',
  STREAMERS_BANNERS = 'STREAMERS_BANNERS',
  STREAMERS_VIDEOS = 'STREAMERS_VIDEOS',
  STREAMERS_NEXT_STREAM_DATE = 'STREAMERS_NEXT_STREAM_DATE',
  USER = 'USER',
  USER_PROMPTS_COUNT = 'USER_PROMPTS_COUNT',
  SYNTH_REWARDS_TOTAL = 'SYNTH_REWARDS_TOTAL',
  SYNTH_REWARDS_CURRENT = 'SYNTH_REWARDS_CURRENT',
  SYNTH_REWARDS_HISTORICAL = 'SYNTH_REWARDS_HISTORICAL',
  SYNTH_REWARDS_AXONS_HISTORICAL = 'SYNTH_REWARDS_AXONS_HISTORICAL',
  SYNTH_REWARDS_AXONS_CURRENT = 'SYNTH_REWARDS_AXONS_CURRENT',
  TOKEN_PRICES = 'TOKEN_PRICES',
  SYNTH_LEADERBOARD_HISTORICAL = 'SYNTH_LEADERBOARD_HISTORICAL',
}
